import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import { BrowserRouter } from 'react-router-dom';
import 'typeface-roboto';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';


import registerServiceWorker from './registerServiceWorker';

import App from './component/App';


const theme = createMuiTheme({
  palette: {
    type: 'dark',
    text:{
      primary: '#fff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
   
    primary: {
      light: '#757ce8',
      main: '#202124',
      dark: '#202124',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      // main: '#f44336',
      main: '#fff',
      dark: '##FFFFFF',
      contrastText: '#000',
    },
    heading:{
      dark: '#fff',
      light: '#000',
    },
    subHeading:{
      dark: 'rgba(255, 255, 255, 0.7)',
      light: '#5f6368',
    }
  
  },
  typography: {
    "fontFamily": ["Roboto", "Helvetica", "Arial", "sans-serif"],
    "fontSize": 14,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500
   },
  overrides: {
    // Name of the component ⚛️ / style sheet
    MuiCard: {
      // Name of the rule
      root: {
        // Some CSS
        background: '#202124',

      },
    },
    MuiPaper: {
      // Name of the rule
      root: {
        // Some CSS
        // backgroundColor: '#fff',
        boxShadow: '0 2px 4px rgba(0,0,0,.5)'
      },
    },
    
    MuiAppBar:{
      root:{
        // height:'72px'
      },
    },
    MuiToolbar:{
      root:{
        backgroundColor:'#202124',
        boxShadow: '0 2px 4px rgba(0,0,0,.5)'
      },

    },
    MuiFormLabel:{
      root:{
       color:'rgba(0, 0, 0, 0.54)',
      },
    },
    MuiInput:{
      input:{
         color:'#000',
      },
      underline:{
        borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: '2px solid rgba(0, 0, 0, 0.87)',
        },
        '&:after': {
          borderBottom: '2px solid #4CAF50',
        },
       },
    },
    MuiFormLabel:{
      root:{
        color:'rgba(0, 0, 0, 0.54)',
        '&$focused':{
          color:'#4CAF50'
        }
      },
      
    
    }
  },
});

ReactDOM.render(  
   <BrowserRouter>
      <MuiThemeProvider theme={theme}>
         <App />
       </MuiThemeProvider>
     </BrowserRouter> 
   , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js